module.exports = __webpack_public_path__ + "img/levelup-icon-arrow-up.92699658.svg";